#import "../OccupationFields.graphql"

query Occupations($orderBy: [UserOccupationTitlesOrderBy!]
  $first: Int
  $after: Cursor 
  $filter: UserOccupationTitleFilter
){
 userOccupationTitles(first: $first, orderBy: $orderBy,filter: $filter, after: $after){
  nodes {
      ...OccupationFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
 }
}

